module.exports = __webpack_public_path__ + "static/img/health.deb2e199.png";